import React from 'react';
import { Form } from 'react-bootstrap';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { InputContainer } from '../styles';
import InputMask from 'react-input-mask';
import { AiOutlineSearch } from 'react-icons/ai';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

interface InputMaskProps {
  label?: string;
  name: string;
  isDisabled?: boolean;
  // register: UseFormRegister<FieldValues>;
  isError: boolean;
  alwaysShowMask?: boolean;
  control: Control<FieldValues, any>;
  hasButton?: boolean;
  loadingIcon?: boolean;
  clickedButton?: () => void;
}

export const InputMaskCnpj: React.FC<InputMaskProps> = ({
  label = '',
  name,
  isError,
  isDisabled = false,
  alwaysShowMask = false,
  control,
  hasButton = false,
  loadingIcon = false,
  clickedButton,
  ...rest
}) => {
  return (
    <>
      <InputContainer>
        <Form.Group>
          <Form.Label>{label}</Form.Label>
          <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange, onBlur, ref } }) => {
              return (
                <InputMask
                  mask="99.999.999/9999-99"
                  alwaysShowMask={alwaysShowMask}
                  // maskPlaceholder="00.000.000/0000-00"
                  placeholder="00.000.000/0000-00"
                  onChange={onChange}
                  disabled={isDisabled}
                  onBlur={onBlur}
                  value={value || ''}
                  className={
                    isError ? 'form-control is-invalid' : 'form-control'
                  }
                  {...rest}
                >
                  {(inputProps: any) => {
                    return (
                      <div style={{ position: 'relative' }}>
                        <input
                          {...inputProps}
                          name={name}
                          type="text"
                          disabled={isDisabled}
                          ref={ref}
                        />
                        {hasButton && (
                          <CustomButtonNovo
                            className="button-input"
                            onClick={() => {
                              if (clickedButton) {
                                clickedButton();
                              }
                            }}
                            icon={AiOutlineSearch}
                            iconOnly
                            showLoading={loadingIcon}
                            iconSize={15}
                          />
                        )}
                      </div>
                    );
                  }}
                </InputMask>
              );
            }}
          />
        </Form.Group>
      </InputContainer>
    </>
  );
};
